/**
 * Shared utilities for Shop components
 */

/**
 * Check if a product has the "Best Seller" tag
 * @param {string|Array} tagsId - Product tag IDs
 * @param {Object} tagsData - Tags data from Redux store
 * @returns {boolean}
 */
export const hasBestSellerTag = (tagsId, tagsData) => {
  if (!tagsId || !tagsData?.tagMasters) return false;

  try {
    let tagIds = [];

    if (typeof tagsId === "string") {
      const cleanedStr = tagsId
        .replace("[", "")
        .replace("]", "")
        .replace(/"/g, "");
      tagIds = cleanedStr
        .split(",")
        .map((id) => id.trim())
        .filter((id) => id);
    } else if (Array.isArray(tagsId)) {
      tagIds = tagsId;
    }

    const bestSellerTag = tagsData.tagMasters.find(
      (tag) => tag.tagMasters.tagName === "Best Seller"
    );

    if (!bestSellerTag) return false;

    return tagIds.includes(bestSellerTag.tagMasters.ROWID);
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.error("Error checking Best Seller tag:", error);
    }
    return false;
  }
};

/**
 * Preload an image URL in memory
 * @param {string} src - Image URL to preload
 * @returns {Promise<void>}
 */
export const preloadImage = (src) => {
  return new Promise((resolve, reject) => {
    if (!src) {
      resolve();
      return;
    }
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject();
    img.src = src;
  });
};

/**
 * Preload multiple images
 * @param {string[]} sources - Array of image URLs
 * @returns {Promise<void>}
 */
export const preloadImages = async (sources) => {
  const validSources = sources.filter(Boolean);
  await Promise.all(validSources.map((src) => preloadImage(src)));
};

